<template>
  <div class="install-page" v-if="isload">
    <div v-if="payload_type == 1">
      <div class="company" v-if="IsAppStoreVer === 1">
        <div class="company-header">
          <img src="../assets/image/download/key.png" /> 玩得赚钥匙
        </div>
        <div class="company-section">
          <div class="top">
            <div class="one">1</div>
            <div class="two">下载安装:</div>
            <div class="three">玩得赚钥匙</div>
          </div>
          <div class="button" :class="{ 'step-btn2': isCompanyBtnText }" @click="goToAppStore(downloadUrl.DownloadUrl, 1)">
            {{ companyBtnText }}
          </div>
          <div class="bottom">新人专享，最高5元微信红包</div>
        </div>

        <div class="company-arrow"></div>

        <div class="company-section company-section2">
          <div class="top">
            <div class="one">2</div>
            <div class="two">安装成功:</div>
            <div class="three">选择描述文件 > 点击信任</div>
          </div>
          <div class="imgs">
            <img src="../assets/image/download/pic.png" />
          </div>
          <div class="button copyBtn" :class="{ 'step-btn2': !IsShowSetting }" @click="goSetting()">点击前往设置</div>
        </div>

        <div class="company-arrow"></div>

        <div class="company-section company-section3">
          <div class="top">
            <div class="one">3</div>
            <div class="two">设置成功:</div>
            <div class="three">去桌面打开【玩得赚钥匙】</div>
          </div>
        </div>
      </div>
      <div class="store" v-if="IsAppStoreVer === 2">
        <div class="store-header">
          <span>【{{ storeUrl.AppName }}】是你登录玩得赚</span>
          <span>做任务赚钱的必备小助手</span>
        </div>

        <div class="store-avatar" v-if="storeUrl.Icon">
          <img :src="storeUrl.Icon">
        </div>

        <div class="store-box">
          <div class="store-desc">来自 {{ storeUrl.AppName }} 的红包</div>
          <div class="store-amount">5.00<span>元</span></div>
          <div class="store-bottom">新人专享，最高5元微信红包</div>
        </div>

        <div class="store-group">
          <div class="btn-store copyBtn" @click="goToAppStore(storeUrl.DownloadUrl, 2)" :data-clipboard-text="PassCode">前往 App Store 下载
          </div>
          <div class="company-arrow">
            <span></span>
          </div>
          <div class="btn-store btn-store3 copyBtn" @click="dakaizs()" :data-clipboard-text="PassCode" v-if="isBaidu">手机桌面【打开小助手】</div>
          <div class="btn-store btn-store3 copyBtn" @click="dakaizs()" :data-clipboard-text="PassCode" v-else>打开小助手</div>
          <div class="store-footer" v-if="isBaidu">
            <p>请返回手机桌面【打开小助手】领取红包</p>
          </div>
          <div class="store-footer" v-else>
            <p>如果打开小助手后没有在首页出现"领微信红包"入口</p>
            <p>请通过点击【打开小助手】再次打开</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="download_type == 1 && isSafari">

      </div>
      <div class="install-content" v-else-if="download_type == 0 && isSafari">
        <div class="header">
          <div class="logo"></div>
          <div class="name">来自玩得赚的红包</div>
          <div class="price">
            <span class="num">5.00</span>
            <span class="unit">元</span>
          </div>
          <div class="desc">新人专享，最高5元微信红包</div>
        </div>
        <div class="buzou" v-if="ios_ver >= 12.2">
          <div class="name">两步安装，永不闪退</div>
          <div class="btn" v-if="!downing" @click="download(1)">1、下载描述文件</div>
          <div class="btn-gray" v-else>正在下载</div>
          <div class="abst">弹窗中请选“允许”，下载描述文件</div>
          <div class="down"></div>
          <div class="btn" @click="download(2)" v-if="ios_ver < 17">2、前往安装</div>
          <div class="btn1" v-else>2、手动安装</div>
          <div class="abst" v-if="ios_ver < 17">无法跳转时，可手动选：<br> 设置-通用-VPN与设备管理-玩得赚</div>
          <div class="abst" v-else>请前往：设置-通用-描述文件-玩得赚</div>
          <div class="down"></div>
          <div class="btn1">从手机桌面启动【玩得赚】</div>
        </div>
        <div class="buzou buzou1" v-else>
          <div class="btn" v-if="!downing" @click="download(1)">添加玩得赚</div>
          <div class="btn-gray" v-else>正在下载</div>
          <div class="abst">弹窗中请选“允许”，下载描述文件</div>
          <div class="down"></div>
          <div class="btn1">从手机桌面启动【玩得赚】</div>
        </div>
      </div>
      <div class="install-no" v-else>
        <div class="header"></div>
        <div class="logo"></div>
        <div class="app-name">玩得赚</div>
        <div class="wap-input">
          <i class="icon iconfont icon-sousuolan-da"></i>
          <div class="copyBtn" @click="copy()" :data-clipboard-text="copy_val">{{ copy_val }}</div>
        </div>
        <div class="wap-btn copyBtn" @click="copy()" :data-clipboard-text="copy_val">复制链接</div>
        <div class="wap-copy">下载【玩得赚】，请点击【复制链接】按钮<br>并在【Safari浏览器】中打开</div>
      </div>
    </div>
    <div class="mask" v-if="browser.wechat || browser.qq" @click="closeMask()">
      <img v-if="browser.android" src="../assets/images/guide_android.png" />
      <img v-if="browser.ios" src="../assets/images/guide_ios.png" />
    </div>
    <div class="mask-layer" v-if="browser.wechat || browser.qq" @click="closeMask()"></div>

    <Copy v-if="showCopy" :name="name" :title="storeUrl.AppName" :url="url" @close="close"></Copy>
  </div>
</template>

<script>
import { utils } from "../utils";
import Clipboard from 'clipboard';
import Copy from "@/components/Copy.vue";
import { Url, BaseUrl, resourceUrl } from "../utils/config.js";
export default {
  name: "install2-page",
  components: {
    Copy
  },
  data() {
    return {
      companyBtnText: '立即安装',
      isCompanyBtnText: false,
      PassCode: '',
      downloadUrl: {},
      storeUrl: {},
      IsAppStoreVer: 0,
      IsShowSetting: false,
      isIos: false,
      guide: {
        show: false,
        type: null
      },
      isBaidu: false,
      browser: {},
      showCopy: false,
      name: '',
      ver: '',
      url: '',
      downing: false,
      ios_ver: 0,
      isSafari: false,
      copy_val: '',
      payload_type: '',//1:App版 2：wap版
      download_type: '',
      isload: false,
    }
  },
  mounted() {
    this.browser = utils.Browser;
    this.ios_ver = this.browser.ios_ver;
    this.isSafari = this.browser.safari;
    this.copy_val = window.location.href.replace('/install', '');
    if (this.browser.wechat || this.browser.qq) {
      document.title = ""
    } else {
      document.title = "玩得赚 - 一个创造价值的试玩APP";
    }
    if (utils.Browser.baidu) {
      this.isBaidu = true;
    }
    // 不是ios系统不允许访问
    if (!utils.Browser.ios & !utils.Browser.ipad & !utils.Browser.iphone) {
      this.$router.push({
        path: '/'
      })
    } else {
      this.loadUrl()
      this.passCodeCreate()
    }
    this.ver = this.ios_ver;
  },
  methods: {
    download(type) {
      if (type == 1) {
        if (this.browser.safari) {
          // 唤出下载弹窗需在safari中才有
          this.downing = true;
          setTimeout(() => {
            this.downing = false;
          }, 5000)
          window.location.href = this.url;
        }
      } else {
        window.location.href = resourceUrl + '/Resource/App/download/setting.mobileprovision?v=' + Math.random();
      }
    },
    loadUrl() { // 下载数据的接口
      this.axios.install().then((res) => {
        this.isload = true;
        this.payload_type = res.data.data.payload_type;
        this.download_type = res.data.data.download_type;
        if (this.payload_type == 2 && this.download_type == 1 && this.isSafari) {
          this.$router.replace({
            path: '/'
          })
        }
        this.url = res.data.data.webclip;
        // URLSchemes 商店版时才有这个字段
        if (res.data.data.URLSchemes) {
          this.IsAppStoreVer = 2
          this.storeUrl = res.data.data
        } else {
          this.IsAppStoreVer = 1
          this.downloadUrl = res.data.data
        }
      })
    },
    goToAppStore(url, type) {
      this.clipboard()
      this.IsShowSetting = true
      if (type === 1) {
        if (this.isCompanyBtnText) {
          return false
        }
        this.companyBtnText = '正在唤起安装弹窗..'
        this.isCompanyBtnText = true

        setTimeout(() => {
          this.isCompanyBtnText = false
          this.companyBtnText = '立即安装'
        }, 3000)
      } else {
        this.clipboard()
      }
      if (this.ver >= 16) {
        this.toPopup(url);
      } else {
        window.location.href = url
      }
    },
    close() {
      this.showCopy = false;
    },
    toPopup(url) {
      this.url = url;
      this.name = '正在前往App Store';
      this.showCopy = true;
    },
    copy() {
      let text = this.copy_val;
      let clipboard = new Clipboard('.copyBtn');
      clipboard.on('success', e => {
        clipboard.destroy(); // 释放内存
        e.clearSelection(); // 清除选中内容
      });
      clipboard.on('error', () => {
        clipboard.destroy();
      });
      this.$toasts.show('链接已复制，请使用Safari浏览器打开');
    },
    goSetting() {
      window.location.href = resourceUrl + '/Resource/App/download/setting.mobileprovision?v=' + Math.random()
    },
    dakaizs() {
      this.clipboard()
      var url = this.storeUrl.URLSchemes + '://';
      if (this.ver >= 16) {
        this.url = url;
        this.name = '正在打开玩得赚助手';
        this.showCopy = true;
      } else {
        window.location.href = url;
      }
    },
    closeMask() { // 关闭提示
      this.isIos = false
    },
    passCodeCreate() { // 口令获取接口
      this.axios.passCodeCreate().then(res => {
        this.PassCode = '{"shifuID":"","activationKey":"' + res.data.data.PassCode + '","type":"9"}';

      })
    },
    clipboard() { // 复制口令
      if (this.PassCode) {
        let clipboard = new Clipboard('.copyBtn');
        clipboard.on('success', e => {
          clipboard.destroy(); // 释放内存
          e.clearSelection(); // 清除选中内容
        });
        clipboard.on('error', () => {
          clipboard.destroy();
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/font/iconfont.css";

.install-page {
  /* prettier-ignore */
  min-width: 320PX;
  min-height: 100%;
  /* prettier-ignore */
  max-width: 600PX;
  box-sizing: border-box;
  margin: 0 auto;

  * {
    padding: 0;
    margin: 0;
  }

  .company {
    .company-header {
      height: 140px;
      line-height: 140px;
      text-align: center;
      background-color: #f25543;
      font-size: 40px;
      color: #ffdb3a;
      margin-bottom: 30px;

      & img {
        width: 88px;
        display: inline-block;
        margin-right: 6px;
      }
    }

    .company-section {
      width: calc(100% - 80px);
      height: 248px;
      overflow: hidden;
      margin: 0 auto;
      padding: 32px 0 32px 32px;
      border-radius: 32px;
      box-sizing: border-box;
      background-color: white;

      .top {
        font-size: 32px;
        height: 40px;
        line-height: 40px;
        color: #999;
        margin-bottom: 24px;

        > div {
          float: left;
        }

        .one {
          width: 40px;
          height: 40px;
          text-align: center;
          border-radius: 40px;
          background-color: #f5f5f5;
          margin-right: 24px;
        }

        .three {
          color: #f25543;
        }
      }

      .button {
        background-color: #f25543;
        width: 460px;
        height: 72px;
        line-height: 72px;
        text-align: center;
        color: white;
        font-size: 28px;
        margin: 0 auto 24px;
        border-radius: 72px;
      }

      .step-btn2 {
        background-color: #cecece !important;
      }

      .bottom {
        color: #42a5f5;
        font-size: 28px;
        text-align: center;
        line-height: 28px;
      }
    }

    .company-section2 {
      height: 440px;

      .imgs {
        display: block;
        width: 460px;
        margin: 0 auto 6px;

        & img {
          width: 100%;
        }
      }
    }

    .company-section3 {
      height: 110px;
      padding: 35px 32px;
    }

    .company-arrow {
      height: 56px;
      line-height: 56px;
      background: url(~@/assets/image/download/jiantou.png) no-repeat center;
      background-size: 36px 28px;
    }
  }

  .store {
    .store-header {
      height: 254px;
      background: #f5f5f5
        url("../assets/image/store/install_appstore_top_bg.png") no-repeat
        center;
      background-size: 100%;
      box-sizing: border-box;
      padding-top: 54px;
      text-align: center;

      & span {
        display: block;
        font-size: 32px;
        line-height: 40px;
        color: #ffe2b1;
      }
    }

    .store-avatar {
      width: 126px;
      height: 126px;
      margin: -72px auto 0;

      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }

    .store-box {
      text-align: center;

      .store-desc {
        font-size: 32px;
        line-height: 32px;
        color: #333;
        margin-top: 24px;
      }

      .store-amount {
        height: 98px;
        font-size: 98px;
        line-height: 98px;
        color: #333;
        margin-top: 30px;

        & span {
          font-size: 32px;
        }
      }

      .store-bottom {
        color: #42a5f5;
        font-size: 26px;
        line-height: 26px;
        margin-top: 26px;
      }
    }

    .store-group {
      position: absolute;
      top: 590px;
      left: 0;
      right: 0;
      bottom: 0;
      padding-top: 60px;
      padding-bottom: 60px;
      background-color: white;
      overflow: hidden;

      .btn-store {
        width: 440px;
        height: 96px;
        line-height: 96px;
        border-radius: 96px;
        margin: 0 auto;
        text-align: center;
        background-color: #f25543;
        color: white;
        cursor: pointer;
        font-size: 29px;
      }

      .btn-store3 {
        background-color: #fff5f5;
        color: #d9593f;
        margin-bottom: 114px;
      }

      .company-arrow {
        height: 80px;
        position: relative;
        display: block;
        width: 100%;
      }

      .company-arrow span {
        position: absolute;
        top: 26px;
        left: 50%;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: inline-block;
        width: 40px;
        height: 28px;
        animation: arrowDown 1.5s linear infinite normal;
        -webkit-animation: arrowDown 1.5s linear infinite normal;
      }

      @keyframes arrowDown {
        from {
          opacity: 0;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAMAAAA+9+1qAAAAVFBMVEUAAADaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPAUW+lAAAAG3RSTlMAZjMVC04fX0buvodaPAbm3sSycFMtyKqXfnq/EyhEAAAA+ElEQVQ4y3VS7QKDIAgkUaOcrbb22fu/5wzWnGH3Cw64IwmAHsHCIWx4EAAuyzKaox4zpjKCWVZc6z1XLiaJiYML6ha8cGlaXZ8cjnHfE0cuPGXjuePsXfa8mezmLfd3Jnr8s+qZuvtMDYGpM20EnZkIQyFOnbCSBbH6zij9ySf3aXPXeMm4cyL6giqiLCLrReEOXq/6tqadsbhDcSWcWwNgm4RbHunTxvnet7VqAZsVZPPP8RcSFzHNcnCqHfjEJdb1bY4ztunWf1Udpy77KFIPKXnN6SmtrpL6ntpKf3GM+U0qGKj5gQZVLq5Q3qluqa20pXHO7K0+dN4To91976EAAAAASUVORK5CYII=);
        }

        to {
          opacity: 1;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAMAAAA+9+1qAAAAVFBMVEUAAADaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPAUW+lAAAAG3RSTlMAZgsVTjIfX0Y27r6HWjzm3sSycFMtyKqXfnrVSTQhAAAA+UlEQVQ4y4WR2xKDIAxEUyAKSlFbe5P//89CcKAomZ6nsJlkdQOA/SqBRa49AohL4AEMj9gVIC8RLaCB0NQMRoaKq2xYXallYt31VCMcQJL7bt+q6Kl2S0401VBeT1a8VqbY7eXBf2f5E/aPnSuZ8Nm10tUvK6orVHcS9qWDifd+xmJZW+Ec2hKMj9zzJCqFefOdmgZgoeLWut2NWkucfVM5OzjgZmq80951oNcGFRuJw5qP8iRhlD9WI0nPrkjCkjTpnMtEgj2kNSQVCJus9pnT/iXebsnuJz5pXKm09ANN3OQzU06ESY/JFsodypV4cAxfjPAPIU7SF3sZE6XdsfR/AAAAAElFTkSuQmCC);
        }
      }

      @-webkit-keyframes arrowDown {
        from {
          opacity: 0;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAMAAAA+9+1qAAAAVFBMVEUAAADaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPAUW+lAAAAG3RSTlMAZjMVC04fX0buvodaPAbm3sSycFMtyKqXfnq/EyhEAAAA+ElEQVQ4y3VS7QKDIAgkUaOcrbb22fu/5wzWnGH3Cw64IwmAHsHCIWx4EAAuyzKaox4zpjKCWVZc6z1XLiaJiYML6ha8cGlaXZ8cjnHfE0cuPGXjuePsXfa8mezmLfd3Jnr8s+qZuvtMDYGpM20EnZkIQyFOnbCSBbH6zij9ySf3aXPXeMm4cyL6giqiLCLrReEOXq/6tqadsbhDcSWcWwNgm4RbHunTxvnet7VqAZsVZPPP8RcSFzHNcnCqHfjEJdb1bY4ztunWf1Udpy77KFIPKXnN6SmtrpL6ntpKf3GM+U0qGKj5gQZVLq5Q3qluqa20pXHO7K0+dN4To91976EAAAAASUVORK5CYII=);
        }

        to {
          opacity: 1;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAMAAAA+9+1qAAAAVFBMVEUAAADaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPAUW+lAAAAG3RSTlMAZgsVTjIfX0Y27r6HWjzm3sSycFMtyKqXfnrVSTQhAAAA+UlEQVQ4y4WR2xKDIAxEUyAKSlFbe5P//89CcKAomZ6nsJlkdQOA/SqBRa49AohL4AEMj9gVIC8RLaCB0NQMRoaKq2xYXallYt31VCMcQJL7bt+q6Kl2S0401VBeT1a8VqbY7eXBf2f5E/aPnSuZ8Nm10tUvK6orVHcS9qWDifd+xmJZW+Ec2hKMj9zzJCqFefOdmgZgoeLWut2NWkucfVM5OzjgZmq80951oNcGFRuJw5qP8iRhlD9WI0nPrkjCkjTpnMtEgj2kNSQVCJus9pnT/iXebsnuJz5pXKm09ANN3OQzU06ESY/JFsodypV4cAxfjPAPIU7SF3sZE6XdsfR/AAAAAElFTkSuQmCC);
        }
      }

      .store-footer {
        text-align: center;
        font-size: 24px;
        color: #999;
        padding-bottom: 40px;

        p {
          line-height: 40px;
          padding: 0;
          margin: 0;
        }
      }
    }
  }

  .install-content {
    width: 750px;

    .header {
      width: 750px;
      height: 616px;
      background: url(~@/assets/images/install/bg@2x.png) no-repeat;
      background-size: 100%;
      display: flex;
      flex-direction: column;

      .logo {
        width: 100;
        height: 128px;
        background: url(~@/assets/images/install/logo@2x.png) no-repeat bottom
          center;
        background-size: 128px;
        padding-top: 72px;
      }

      .name {
        font-size: 32px;
        color: #ffffff;
        text-align: center;
        margin-top: 16px;
      }

      .price {
        display: flex;
        align-items: baseline;
        justify-content: center;
        height: 124px;

        .num {
          font-size: 88px;
          font-weight: bold;
          color: #ffe89b;
        }

        .unit {
          font-size: 32px;
          color: #ffe89b;
        }
      }

      .desc {
        font-size: 24px;
        text-align: center;
        color: #ffc8bc;
      }
    }

    .buzou {
      width: 666px;
      margin-top: -144px;
      background: #fff;
      margin-left: 42px;
      border-radius: 16px;
      padding-bottom: 128px;

      &.buzou1 {
        padding-top: 96px;
      }

      .name {
        font-size: 28px;
        color: #42a5f5;
        text-align: center;
        padding-top: 32px;
      }

      .btn {
        margin-top: 32px;
        width: 440px;
        height: 88px;
        background: #d9593f;
        border-radius: 48px;
        margin-left: 114px;
        font-size: 32px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .btn-gray {
        margin-top: 32px;
        width: 440px;
        height: 88px;
        background: #999999;
        border-radius: 48px;
        margin-left: 114px;
        font-size: 32px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .btn1 {
        margin-top: 32px;
        width: 440px;
        height: 88px;
        background: #ffffff;
        border: 1px solid #d9593f;
        border-radius: 48px;
        margin-left: 114px;
        font-size: 32px;
        color: #d9593f;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .abst {
        font-size: 24px;
        color: #999999;
        margin-top: 24px;
        text-align: center;
      }

      .down {
        width: 100%;
        height: 36px;
        margin-top: 24px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAMAAAA+9+1qAAAAVFBMVEUAAADaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPaTUPAUW+lAAAAG3RSTlMAZgsVTjIfX0Y27r6HWjzm3sSycFMtyKqXfnrVSTQhAAAA+UlEQVQ4y4WR2xKDIAxEUyAKSlFbe5P//89CcKAomZ6nsJlkdQOA/SqBRa49AohL4AEMj9gVIC8RLaCB0NQMRoaKq2xYXallYt31VCMcQJL7bt+q6Kl2S0401VBeT1a8VqbY7eXBf2f5E/aPnSuZ8Nm10tUvK6orVHcS9qWDifd+xmJZW+Ec2hKMj9zzJCqFefOdmgZgoeLWut2NWkucfVM5OzjgZmq80951oNcGFRuJw5qP8iRhlD9WI0nPrkjCkjTpnMtEgj2kNSQVCJus9pnT/iXebsnuJz5pXKm09ANN3OQzU06ESY/JFsodypV4cAxfjPAPIU7SF3sZE6XdsfR/AAAAAElFTkSuQmCC)
          no-repeat center center;
        background-size: 36px;
        animation: arrow-down 1.5s linear infinite normal;
      }
    }
  }

  .install-no {
    height: 100vh;
    background: #fff;

    .header {
      height: 254px;
      background: #ffffff
        url("../assets/image/store/install_appstore_top_bg.png") no-repeat
        center;
      background-size: 100%;
    }

    .logo {
      width: 100%;
      height: 128px;
      background: url(~@/assets/images/install/logo@2x.png) no-repeat bottom
        center;
      background-size: 128px;
      margin-top: -64px;
    }

    .app-name {
      font-size: 32px;
      color: #333333;
      text-align: center;
      margin-top: 28px;
    }

    .wap-btn {
      margin-top: 48px;
      width: 440px;
      height: 88px;
      background: #d9593f;
      border-radius: 48px;
      margin-left: 156px;
      font-size: 32px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .wap-copy {
      font-size: 28px;
      color: #666666;
      text-align: center;
      margin-top: 64px;
    }

    .wap-input {
      width: 592px;
      height: 84px;
      background: #f9f9f9;
      border-radius: 16px;
      margin-top: 80px;
      margin-left: 80px;
      display: flex;
      align-items: center;

      .icon {
        font-size: 48px;
        color: #999999;
        margin-left: 24px;
        margin-right: 18px;
      }

      div {
        font-size: 24px;
        width: 464px;
        line-height: 84px;
        display: flex;
        white-space: nowrap;
        overflow-x: scroll;
      }
    }
  }
}

@keyframes arrow-down {
  from {
    opacity: 0;
    bottom: 0%;
  }

  to {
    bottom: 10%;
    opacity: 1;
  }
}

.mask {
  width: 750px;
  position: absolute;
  right: 9px;
  top: 20px;
  z-index: 10000;

  img {
    width: 750px;
  }
}

.mask-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f44336;
  // opacity: 0.7;
  z-index: 1000;
}
</style>